var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3fafe;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.83,31.09c-1.35,4.3-4.21,7.91-8.89,8.72-2.55.44-5.3.14-7.88.14-2.7,0-5.42.14-8.12-.02v-2.03c4.36-.22,8.77-.07,13.13-.03,3.53.03,7.06-1.36,8.81-4.62,1.55-2.89,1.44-6.5-.42-9.21-2.37-3.46-5.64-4.08-9.59-4.08,1.19-7.49-3.97-14.93-11.64-15.88-6.3-.78-12.75,3.34-14.62,9.42-2.24-1.04-4.13-2.01-6.63-1.16-1.99.67-3.27,2.25-3.78,4.25-.36,1.4-.7,1.58-2.01,2.16-.98.43-1.86.9-2.65,1.64-1.62,1.49-2.86,3.31-3.24,5.5-.83,4.84,1.57,9.66,6.27,11.4,2.43.9,5.11.58,7.66.58,2.92,0,5.83.01,8.75.01v2.13c-4.54,0-9.09.1-13.63-.02-3.59-.1-6.65-1.96-8.86-4.73C.06,32.2-.64,27.9.6,24.22c1.24-3.69,3.88-6.22,7.48-7.59,1.29-5.31,6.34-8.15,11.49-5.9C23.33,3.94,30.69.27,38.29,2.76c6.86,2.24,10.44,8.02,10.93,15.04,5.44.66,9.23,3.29,10.57,8.88.17,1.14.34,2.46.03,4.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.05,48.89c-3,3.07-5.93,6.08-8.91,9.13-3.12-3.07-6.14-6.04-9.17-9.02.49-.49.94-.94,1.5-1.5,2.13,2.12,4.25,4.24,6.45,6.44v-26.03h2.15v26.08c1.54-1.16,2.86-2.74,4.21-4.1.49-.5,1.38-1.86,2.03-2.1.67-.25,1.29.68,1.73,1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExport);
export default __webpack_public_path__ + "static/media/Import-export.400c4956629ea55e3ff1ec089d52e934.svg";
export { ForwardRef as ReactComponent };